const WORDS = ["Автосервиз", "Диагностика", "Акумулатори", "Механика", "Автоклиматици", "Хасково", "Автолампи", "Обслужване"];

export default function Marquee() {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {WORDS.map((w, i) => (
        <span key={`${key}-${i}`} className="flex items-center">
          <span className={`font-display text-4xl font-extrabold uppercase tracking-tight sm:text-6xl ${i % 2 === 0 ? "text-stroke-white" : "text-[#39FF14]"}`}>
            {w}
          </span>
          <span className="mx-8 text-2xl text-[#39FF14]/50 sm:mx-12">✦</span>
        </span>
      ))}
    </div>
  );

  return (
    <div className="overflow-hidden border-y border-white/10 bg-[#0A0A0A] py-8" data-testid="marquee-section" aria-hidden="true">
      <div className="marquee-track flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
